var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"pa-2":"","sm12":""}},[_c('burndown-chart')],1),_c('v-flex',{attrs:{"pa-2":"","sm12":""}},[_c('scrum-board')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }